import axios from "axios";
import { config } from "../shared/app.config";

const RESOURCE_NAME = "/document-categories";
const RESOURCE_NAME_DOCUMENT = "/documents";

export default {
  deleteCategory(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`);
  },
  editCategory(id, category) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, category);
  },
  createCategory(category) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, category);
  },
  list(page, per_page, search, client_id, active = '') {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      page,
      per_page,
      search,
      client_id,
      active
    });
  },
  getCategory(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`);
  },
  createDocument(document) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_DOCUMENT}`, document);
  },
  createDocumentBulk(document) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_DOCUMENT }/upload-docs`, document);
  },
  listDocuments(client_id, user_id, category_id) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_DOCUMENT}/list`, {
      client_id,
      user_id,
      category_id,
    });
  },
  deleteDocument(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME_DOCUMENT}/${id}`);
  },
};
